import { Component, OnInit } from '@angular/core';
import { IFilterFilters } from '../ifilter';
import { Datalistrequestfilter } from '../../request/datalistrequestfilter';
import { EnforcementService } from 'src/app/Services/enforcement.service';

@Component({
    selector: '[app-officers-filter]',
    templateUrl: './officers-filter.component.html',
    styleUrls: ['./officers-filter.component.scss'],
    host: { 'class': 'control' },
    standalone: false
})
export class OfficersFilterComponent implements OnInit, IFilterFilters {
  public Officers: any[] = [];
  public SelectedOfficerId: string = "all";
  public FilterName: string = "officer";
  public Filters: Datalistrequestfilter[] = [];
  public QueryParamPrefix: string = '';
  public loading = false;

  constructor(private enforcementService: EnforcementService) {}

  async ngOnInit(): Promise<void> {
    this.loading = true;
    try {
      // Load all active officers
      const response: any = await this.enforcementService.searchOfficers({
        PageSize: 100,
        PageIndex: 0,
        Subset: 'Active',
        Search: '',
        Filters: [],
        OrderByProperty: 'UserName',
        Ascending: true
      });
      
      if (response && response.Data) {
        this.Officers = response.Data;
      }
    } catch (error) {
      console.error('Failed to load officers for filter', error);
    } finally {
      this.loading = false;
    }
  }

  public addOfficerFilter(event: any) {
    const val = event.target.value;
    this.Filters = [];

    if (val !== "" && val !== "all") {
      this.Filters.push({
        Property: "OfficerId",
        Comparator: "==",
        Value: val,
        FilterName: this.FilterName
      });
      this.SelectedOfficerId = val;
    } else {
      this.SelectedOfficerId = "";
    }
  }
}

